import React from "react";
import { Form, Switch } from "antd";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const FormSwitch = (props) => {
  // -------------------------- VAR -----------------------------
  const name = props?.name || "Tên";
  const label = props?.label || "Tiêu đề";
  const initialValue = props?.initialValue;
  const checkedChildren = props?.checkedChildren;
  const unCheckedChildren = props?.unCheckedChildren;
  const disabled = props?.disabled;

  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Form.Item
      name={name}
      label={label}
      initialValue={initialValue}
      valuePropName="checked"
    >
      <Switch
        checkedChildren={checkedChildren}
        unCheckedChildren={unCheckedChildren}
        disabled={disabled}
      />
    </Form.Item>
  );
};
export default FormSwitch;
